module.exports = __webpack_public_path__ + "static/media/step-5-id.8bb1373c.jpg";